angular.module('FlexyBeautyApp.services')
    .factory('UboStatementView', ["UboStatementData", "UboStatementSrv", "UboStatement", "Ubo", "UboView", "UboStatus",
        function (UboStatementData, UboStatementSrv, UboStatement, Ubo, UboView, UboStatus) {
            let UboStatementView = function (uboStatement) {
                this.id = null;
                this.details = null;
                this.status = null;
                this.timeCreated = null;

                this.ubosView = [];

                if (uboStatement) {
                    this.loadDataFrom(uboStatement);
                }
            };

            UboStatementView.prototype.loadDataFrom = function (uboStatement) {
                this.id = uboStatement.id;
                this.details = uboStatement.details;
                this.status = uboStatement.status;
                this.timeCreated = uboStatement.timeCreated;
                for (let i = 0; i < uboStatement.ubos.length; i++) {
                    let uboView = new UboView(uboStatement.ubos[i]);
                    if (this.status && this.status !== UboStatus.INCOMPLETE.id) {
                        uboView.isReadOnly = true;
                    }
                    this.ubosView.push(uboView);
                }
            };

            UboStatementView.prototype.getModel = function () {
                return UboStatementData.getById(this.id) || new UboStatement();
            };

            UboStatementView.prototype.updateModel = function () {
                let uboStatement = this.getModel();
                for (let i = 0; i < this.ubosView.length; i++) {
                    let ubo = uboStatement.ubos[i];
                    if (!ubo) {
                        ubo = new Ubo();
                        uboStatement.ubos.push(ubo);
                    }
                    this.ubosView[i].copyDataTo(ubo);
                }

                return uboStatement.id ? UboStatementSrv.update(uboStatement) : UboStatementSrv.save(uboStatement);
            };

            return UboStatementView;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/views/UboStatementView.js